/* bo-clarity-preventa.js — formulario waitlist + carrusel + sticky CTA */
(function () {
  'use strict';
  var root = document.getElementById('bo-clw');
  if (!root) return;
  var endpoint = root.getAttribute('data-endpoint') || '';
  var LS_KEY = 'bo_clw_joined_v1';

  /* ---------- Formulario ---------- */
  function normalizePhone(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.length === 11 && d.indexOf('591') === 0) d = d.slice(3);
    if (d.length === 8 && (d[0] === '6' || d[0] === '7')) return d;
    return null;
  }

  function markDone(form, already, focus) {
    form.classList.add('is-done');
    var ok = form.querySelector('[data-clw-ok]');
    if (ok) {
      if (already) {
        var t = ok.querySelector('strong');
        if (t) t.textContent = 'Ya estabas en la lista';
      }
      ok.hidden = false;
      if (focus) {
        ok.setAttribute('tabindex', '-1');
        ok.focus({ preventScroll: true });
      }
    }
  }

  function setErr(form, msg) {
    var err = form.querySelector('[data-clw-err]');
    if (!err) return;
    if (msg) { err.textContent = msg; err.hidden = false; }
    else { err.textContent = ''; err.hidden = true; }
  }

  var forms = root.querySelectorAll('[data-clw-form]');

  // Si ya se registró en este dispositivo, mostrar el estado "listo".
  var joined = false;
  try { joined = !!localStorage.getItem(LS_KEY); } catch (e) {}
  if (joined) forms.forEach(function (f) { markDone(f, true, false); });

  forms.forEach(function (form) {
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      setErr(form, '');
      var nameIn = form.querySelector('input[name="name"]');
      var phoneIn = form.querySelector('input[name="phone"]');
      var btn = form.querySelector('[data-clw-btn]');
      var name = (nameIn.value || '').trim();
      var phone = normalizePhone(phoneIn.value);

      nameIn.setAttribute('aria-invalid', name.length < 2 ? 'true' : 'false');
      phoneIn.setAttribute('aria-invalid', phone ? 'false' : 'true');

      if (name.length < 2) { setErr(form, 'Escribe tu nombre para poder avisarte.'); nameIn.focus(); return; }
      if (!phone) { setErr(form, 'Revisa tu celular: son 8 dígitos y empieza en 6 o 7.'); phoneIn.focus(); return; }
      if (!endpoint) { setErr(form, 'El registro no está disponible en este momento. Escríbenos por WhatsApp.'); return; }

      btn.disabled = true;
      var label = btn.querySelector('[data-clw-btn-label]');
      var prev = label ? label.textContent : '';
      if (label) label.textContent = 'Registrando…';

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: name, phone: phone, source: 'alpha-clarity-preventa' })
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (data) {
          if (data && data.ok) {
            try { localStorage.setItem(LS_KEY, '1'); } catch (e) {}
            forms.forEach(function (f) { markDone(f, f !== form ? true : !!data.already, f === form); });
            if (!data.already && typeof window.boTrack === 'function') {
              window.boTrack('Lead', { content_name: 'Alpha Clarity Waitlist', content_category: 'preventa' });
            }
          } else if (data && data.error === 'phone') {
            setErr(form, 'Revisa tu celular: son 8 dígitos y empieza en 6 o 7.');
          } else {
            setErr(form, 'No pudimos registrarte. Intenta de nuevo en unos segundos.');
          }
        })
        .catch(function () {
          setErr(form, 'Sin conexión. Revisa tu internet e intenta de nuevo.');
        })
        .then(function () {
          btn.disabled = false;
          if (label) label.textContent = prev;
        });
    });
  });

  /* ---------- Carrusel: dots ---------- */
  var carousel = root.querySelector('[data-carousel]');
  var dotsWrap = root.querySelector('[data-dots]');
  if (carousel && dotsWrap) {
    var slides = carousel.querySelectorAll('.bo-clw__slide');
    slides.forEach(function () { dotsWrap.appendChild(document.createElement('span')); });
    var dots = dotsWrap.querySelectorAll('span');
    function syncDots() {
      var mid = carousel.scrollLeft + carousel.clientWidth / 2;
      var idx = 0;
      slides.forEach(function (s, i) {
        if (s.offsetLeft <= mid) idx = i;
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
    }
    carousel.addEventListener('scroll', function () {
      window.requestAnimationFrame(syncDots);
    }, { passive: true });
    syncDots();
  }

  /* ---------- Videos: pausar fuera de viewport ---------- */
  if ('IntersectionObserver' in window) {
    var vids = root.querySelectorAll('video');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.play().catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- Sticky CTA móvil ---------- */
  var sticky = root.querySelector('[data-sticky]');
  var stickyBtn = root.querySelector('[data-sticky-btn]');
  var heroForm = document.getElementById('bo-clw-f1');
  var finalSec = document.getElementById('bo-clw-final');
  if (sticky && stickyBtn && heroForm && 'IntersectionObserver' in window) {
    var heroVisible = true, finalVisible = false, done = joined;
    function refresh() {
      var show = !heroVisible && !finalVisible && !done && window.innerWidth < 900;
      sticky.hidden = !show;
    }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { heroVisible = e.isIntersecting; });
      refresh();
    }, { threshold: 0.05 }).observe(heroForm);
    if (finalSec) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { finalVisible = e.isIntersecting; });
        refresh();
      }, { threshold: 0.05 }).observe(finalSec);
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-sticky-btn]')) {
        (finalSec || heroForm).scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
    // si el usuario se registra, ocultar el sticky
    forms.forEach(function (f) {
      f.addEventListener('submit', function () {
        setTimeout(function () {
          done = f.classList.contains('is-done') || done;
          refresh();
        }, 1200);
      });
    });
    window.addEventListener('resize', refresh, { passive: true });
    refresh();
  }
})();
